import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MobileArrowIcon from '../../../icons/Claims/MobileArrowIcon';
import DesktopArrowIcon from '../../../icons/Claims/DesktopArrowIcon';

import useStyles from './makeStyles';

const ArrowIosIcon = ({ isDeviceMdSize }) => {
  const { t } = useTranslation();
  const classes = useStyles({ isDeviceMdSize });

  return (
    <Grid
      item
      className={classes.root}
      md={2}
      style={{
        flexDirection: 'row',
        alignItems: isDeviceMdSize ? 'center' : 'flex-end',
      }}
    >
      {
        isDeviceMdSize ? <MobileArrowIcon /> : <DesktopArrowIcon />
      }
      <p>{t('searchApplicant.or')}</p>
      {
        isDeviceMdSize ? <MobileArrowIcon rotate={180} /> : <DesktopArrowIcon rotate={180} />
      }
    </Grid>
  );
};

ArrowIosIcon.propTypes = {
  isDeviceMdSize: PropTypes.bool.isRequired,
};

export default ArrowIosIcon;
